import React, { useState, useRef, useEffect } from "react";
import { API, Auth } from "aws-amplify";
import Cryptr from "cryptr";
import { useDispatch, useSelector } from "react-redux";
import { Constants } from "../../config/constants";
import config from "../../config/aws-exports";
import { awsSignIn, authData } from "../../redux/auth/authSlice";
import { setIL, resetIL, iLData } from "../../redux/auth/iLearnSlice";
import {
  Container,
  Dropdown,
  Grid,
  Header,
  Image,
  List,
  Menu,
  Segment,
  Button,
} from "semantic-ui-react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import {
  CircularProgress,
  SwipeableDrawer,
  Box,
  ListItemIcon,
  Divider,
  ListItem,
  ListItemText,
} from "@material-ui/core";
import ExploreIcon from "@material-ui/icons/Explore";
import InboxIcon from "@material-ui/icons/Inbox";
import MenuIcon from "@material-ui/icons/Menu";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import TextField from "@material-ui/core/TextField";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Link, useNavigate, useParams } from "react-router-dom";
import "./a.scss";
import Password from "../../assets/svgjs/password";

import appHeaderStyle from "./appHeader.module.scss";

import logo from "../../assets/images/africalogo.png";
import EmailIcon from "../../assets/svgjs/email";
import Loginicon from "../../assets/images/Login_icon – 1.png";
import swal from "sweetalert";

const useStyles = makeStyles((theme) => ({
  MenuIconList: {
    textDecoration: "none",
    "& li > button > span > div > svg": {
      width: "2.5rem",
      height: "2.5rem",
      color: "#217fb4",
    },
    "& li > button > span > div > span": {
      fontSize: "1.3rem",
    },
    "& div > button > span > div > svg": {
      width: "2.5rem",
      height: "2.5rem",
      color: "#217fb4",
    },
    "& div > button > span > div > span": {
      fontSize: "1.3rem",
    },
  },
  modal: {
    "& .MuiInputBase-input": {
      fontSize: "medium ",
      paddingLeft: "34px",
      "@media (max-width: 600px)": {
        paddingLeft: "20px",
      },
    },
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)",
    textBox: {
      "& .MuiInputBase-input": {
        fontSize: "medium ",
        paddingLeft: "34px",
      },
    },
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    height: "auto",
    width: "600px",
    borderRadius: "4px",
    border: "none",
    padding: theme.spacing(2, 4, 3),
    "@media (max-width: 600px)": {
      width: "300px",
    },
  },
  SignInPaper: {
    backgroundColor: theme.palette.background.paper,
    height: "auto",
    width: "600px",
    borderRadius: "4px",
    border: "none",
    padding: theme.spacing(2, 4, 3),
    "@media (max-width: 600px)": {
      width: "300px",
    },
  },
  forgotPasswordPaper: {
    backgroundColor: theme.palette.background.paper,
    height: "auto",
    width: "600px",
    borderRadius: "4px",
    border: "none",
    padding: theme.spacing(2, 4, 3),
    "@media (max-width: 600px)": {
      width: "300px",
    },
  },
  ResetPasswordPaper: {
    backgroundColor: theme.palette.background.paper,
    height: "auto",
    width: "600px",
    borderRadius: "4px",
    border: "none",
    padding: theme.spacing(2, 4, 3),
    "@media (max-width: 600px)": {
      width: "300px",
    },
  },
  ResetPasswordPaperFirst: {
    backgroundColor: theme.palette.background.paper,
    height: "auto",
    width: "600px",
    borderRadius: "4px",
    border: "none",
    padding: theme.spacing(2, 4, 3),
    "@media (max-width: 600px)": {
      width: "300px",
    },
  },
  root: {
    textAlign: "center",
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "25ch",
    },
  },
  MenuIconList: {
    textDecoration: "none",
    "& li > button > div > svg": {
      width: "2.5rem",
      height: "2.5rem",
      color: "#217fb4",
    },
    "& li > button > div > span": {
      fontSize: "1.3rem",
      textTransform: "uppercase",
    },
    "& li > button": {
      color: "black!important",
      border: "0!important",
      cursor: "pointer!important",
      margin: "0!important",
      display: "inline-flex!important",
      outline: "0!important",
      position: "relative!important",
      alignItems: "center!important",
      userSelect: "none!important",
      verticalAlign: "middle!important",
      justifyContent: "center",
      textDecoration: "none!important",
      backgroundColor: "transparent!important",
    },
  },
  menuLogo: {
    width: "60%",
    padding: "0.3rem 0rem 0rem",
    margin: "auto",
  },
  mainMenu: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    "@media (max-width: 900px)": {
      display: "none!important",
    },
  },
  logoResponsiveContainer: {
    height: "100%",
    display: "flex",
    "@media (max-width: 900px)": {
      display: "block",
      textAlign: "center",
      width: "100%",
    },
  },
  logoResponsiveMobileContainer: {
    marginLeft: "0.5rem",
    color: "white",
    "@media (min-width: 900px)": {
      display: "none",
    },
  },
  logoResponsive: {
    marginRight: "1.5em",
    height: "100%!important",
    width: "auto",
    "@media (max-width: 900px)": {
      display: "inline-block!important",
      marginRight: 0,
    },
  },
  forgotPW: {
    margin: "0rem -25rem 0 0",
    textAlign: "end",
    cursor: "pointer",
    fontSize: "small",
    "@media (max-width: 600px)": {
      margin: "0rem -11rem 0 0",
    },
  },
  noteText: {
    fontSize: "10px",
    width: "67%",
    margin: "auto",
    textAlign: "center",
    color: "rgba(0, 0, 0, 0.4)",
    "@media (max-width: 600px)": {
      width: "100%",
    },
  },

  MenuIconListMobile: {
    textAlign: "center",
    "& > a": {
      color: "black!important",
      fontSize: "1.5rem!important",
      textDecoration: "none",
      //padding: "2rem!important",
      "& > div": {
        fontSize: "1.5rem",
        display: "flex!important",
        justifyContent: "center!important",
        color: "black!important",
        width: "100%",
        padding: "2rem",
        "& > div": {
          left: "auto!important",
          "& > a": {
            color: "black!important",
            padding: "1rem!important",
            display: "block",
            margin: "0!important",
          },
          "& > div": {
            display: "flex!important",
            fontSize: "1.5rem!important",
            padding: "1rem!important",
            "& > div": {
              left: "3rem!important",
              top: "4rem!important",
            },
          },
        },
      },
    },
  },
}));

function AppHeader({ mpbpid }) {
  const [email, setEmail] = useState("");
  const [drawerState, setDrawerState] = React.useState(false);
  const [password, setPassword] = useState("");
  const [emailTextIssue, setEmailTextIssue] = useState("");
  const [passTextIssue, setPassTextIssue] = useState("");
  const [user, setUser] = useState("");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [signInOpen, setSignInOpen] = useState(false);
  const [forgotPasswordOpen, setForgotPasswordOpen] = useState(false);
  const [resetPasswordOpen, setResetPasswordOpen] = useState(false);
  const [resetPasswordOpenFirst, setResetPasswordOpenFirst] = useState(false);
  const [cognitoErrorUsername, setcognitoErrorUsername] = useState("");
  const [cognitoErrorPassword, setcognitoErrorPassword] = useState("");
  const [ils, setIls] = useState(false);
  let navigate = useNavigate();
  const emailInput = useRef();
  const passwordInput = useRef();
  const clearEmail = () => emailInput.current.clear();

  //register
  const [name, setName] = useState("");
  const [regEmail, setRegEmail] = useState("");
  const [regPassword, setRegPassword] = useState("");
  const [regConfirmPassword, setRegConfirmPassword] = useState("");
  const [regCognitoErrorUsername, setRegCognitoErrorUsername] = useState("");
  const [regCognitoErrorPassword, setRegCognitoErrorPassword] = useState("");
  const [regEmailTextIssue, setRegEmailTextIssue] = useState("");
  const [regNameTextIssue, setRegNameTextIssue] = useState("");
  const [regPassTextIssue, setRegPassTextIssue] = useState("");
  const [regConfirmpassTextIssue, setRegConfrimPassTextIssue] = useState("");

  //forgot password
  const [forgotPasswordEmail, setForgotPasswordEmail] = useState("");
  const [forgotPasswordEmailTextIssue, setForgotPasswordEmailTextIssue] =
    useState("");
  const [
    forgotPasswordCognitoErrorUsername,
    setForgotPasswordCognitoErrorUsername,
  ] = useState("");

  //Reset password
  const [verificationCode, setVerificationCode] = useState("");
  const [resetPassword, setResetPassword] = useState("");
  const [confirmResetPassword, setConfirmResetPassword] = useState("");
  const [resetPassVerificationCode, setResetPassVerificationCode] =
    useState("");
  const [resetPasswordCodeIssue, setResetPasswordCodeIssue] = useState("");
  const [resetPasswordMatch, setResetPasswordMatch] = useState("");
  //reset first time

  const [resetPasswordFirst, setResetPasswordFirst] = useState("");
  const [confirmResetPasswordFirst, setConfirmResetPasswordFirst] =
    useState("");
  const [resetPassVerificationCodeFirst, setResetPassVerificationCodeFirst] =
    useState("");
  const [resetPasswordCodeIssueFirst, setResetPasswordCodeIssueFirst] =
    useState("");
  const [resetPasswordMatchFirst, setResetPasswordMatchFirst] = useState("");

  const dispatch = useDispatch();
  const classes = useStyles();

  const [ApplicationCate, setApplicationCate] = useState({});
  const [certificateData, setCertificateData] = useState([]);
  const [diplomaData, setDiplomaData] = useState([]);
  const [graduateData, setGraduateData] = useState([]);
  const [pgDiplomaData, setPgDiplomaData] = useState([]);
  const [underGraduateData, setUnderGraduateData] = useState([]);

  const { pid, il } = useParams();
  const [pidS, setPidS] = useState(pid);
  const [ilST, setIlST] = useState(il);

  const cryptr = new Cryptr("myTotalySecretKey");
  const idata = useSelector(iLData);
  let userDetails = useSelector(authData);

  console.log("userDetails", userDetails);

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setDrawerState(open);
  };

  const DrawerList = (anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <nav aria-label="main mailbox folders">
        <List className={classes.MenuIconListMobile}>
          <ListItem
            disablePadding
            style={{
              padding: "0",
              justifyContent: "center",
              padding: "0 4rem",
            }}
          >
            <Image
              size="small"
              src={`https://${
                Constants.DOMAIN
              }/${config.aws_org_id.toLocaleLowerCase()}-resources/images/org-images/logo.jpg`}
            />
          </ListItem>
          <Divider style={{ margin: "0.4rem 0rem" }} />
          <Link to={``} className={classes.MenuIconList}>
            <Dropdown
              icon="dropdown"
              text="About"
              style={{ float: "right", color: "white" }}
              position="right"
              className="link item"
            >
              <Dropdown.Menu>
                <Link
                  to={`/aboutJssaher`}
                  style={{ color: "white", marginTop: "12px" }}
                >
                  {" "}
                  <Dropdown.Item>JSSAHER</Dropdown.Item>
                </Link>
                <Link
                  to={`/aboutOEP`}
                  style={{ color: "white", marginTop: "12px" }}
                >
                  {" "}
                  <Dropdown.Item>Online Learning</Dropdown.Item>
                </Link>
              </Dropdown.Menu>
            </Dropdown>
          </Link>
          <Link to={``} className={classes.MenuIconList}>
            <Dropdown text="Programs">
              <Dropdown.Menu>
                <Dropdown className="link item" text="Post Graduate">
                  {graduateData.length === 0 ? (
                    <div></div>
                  ) : (
                    <Dropdown.Menu>
                      {graduateData.map((item) => (
                        <Dropdown.Item onClick={() => toNavigate(item)}>
                          <p
                            dangerouslySetInnerHTML={{ __html: item.pname }}
                          ></p>
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  )}
                </Dropdown>
                <Dropdown text="Under Graduate">
                  {underGraduateData.length === 0 ? (
                    <div></div>
                  ) : (
                    <Dropdown.Menu>
                      {underGraduateData.map((item) => (
                        <Dropdown.Item onClick={() => toNavigate(item)}>
                          <p
                            dangerouslySetInnerHTML={{ __html: item.pname }}
                          ></p>
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  )}
                </Dropdown>
                <Dropdown className="link item" text="Diploma">
                  {diplomaData.length === 0 ? (
                    <div></div>
                  ) : (
                    <Dropdown.Menu>
                      {diplomaData.map((item) => (
                        <Dropdown.Item onClick={() => toNavigate(item)}>
                          <p
                            dangerouslySetInnerHTML={{ __html: item.pname }}
                          ></p>
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  )}
                </Dropdown>
                <Dropdown className="link item" text="Certificate">
                  {certificateData.length === 0 ? (
                    <div></div>
                  ) : (
                    <Dropdown.Menu>
                      {certificateData.map((item) => (
                        <Dropdown.Item onClick={() => toNavigate(item)}>
                          <p
                            dangerouslySetInnerHTML={{ __html: item.pname }}
                          ></p>
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  )}
                </Dropdown>
              </Dropdown.Menu>
            </Dropdown>
          </Link>

          {/* <Link to={``} className={classes.MenuIconList}>
        <Dropdown
          className="link item"
          text="Admissions"
          style={{ color: "white" }}
        >
          <Dropdown.Menu>
            <Link
              to={`/onlineProgram`}
              style={{ color: "white", marginTop: "12px" }}
            >
              {" "}
              <Dropdown.Item>Online Program</Dropdown.Item>
            </Link>
          </Dropdown.Menu>
        </Dropdown>
        </Link>

        <Menu.Item
          as="a"
          href="http://www.infoblog.jssuni.edu.in/"
          target="_blank"
          style={{ color: "white" }}
        >
          Research forum
        </Menu.Item> */}

          <Link
            to={`/contactUs`}
            style={{
              color: "white",
              textDecoration: "none",
            }}
          >
            <Menu.Item style={{ color: "white" }}>Contact us</Menu.Item>
          </Link>

          <Button
            className={appHeaderStyle.loginButton}
            style={{ marginBottom: "2rem" }}
            onClick={() => {
              if (il == "1") {
                setOpen(true);
              } else {
                setOpen(true);
              }
            }}
          >
            Login
            {/* {il == "1"? "/ Apply" : null}  */}
            {/* {JSON.stringify(idata)} */}
          </Button>
        </List>
      </nav>
      <Divider />
    </Box>
  );

  useEffect(() => {
    getProgramsList();
  }, []);

  useEffect(() => {
    if (il == "1") {
      setIls(true);
    } else {
      setIls(false);
      // dispatch(resetIL());
    }
    let obj = {};
    console.log(idata);
    if (idata != 0 && pid && il) {
      obj = {
        ...idata,
        pid: pid,
        il: il,
      };
      dispatch(setIL(obj));
    } else if (pid && il) {
      obj = {
        pid: pid,
        il: il,
      };
      dispatch(setIL(obj));
    }
  }, [il, pid, mpbpid]);

  async function getProgramsList() {
    const bodyParam = {
      body: {
        oid: config.aws_org_id,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.ALL_PROGRAM,
        bodyParam
      );
      const ProgramsList = response;
      setApplicationCate(ProgramsList);
      setCertificateData(ProgramsList.certificate);
      setDiplomaData(ProgramsList.diploma);
      setGraduateData(ProgramsList.graduate);
      setPgDiplomaData(ProgramsList.pgdiploma);
      setUnderGraduateData(ProgramsList.undergraduate);
      console.log("Apply1", ProgramsList);
    } catch (error) {
      console.error(error);
    }
  }

  const openLogin = () => {
    setOpen(true);
    setSignInOpen(false);
  };

  const openSignIn = () => {
    setSignInOpen(true);
    setOpen(false);
  };

  const forgotPasswordSwap = () => {
    setForgotPasswordOpen(true);
    setOpen(false);
    setEmail("");
    setPassword("");
    setEmailTextIssue("");
    setPassTextIssue("");
  };

  const resetPasswordOpenFunction = () => {
    setResetPasswordOpen(true);
    setOpen(false);
  };

  const emailOnKeyPress = () => {
    setcognitoErrorUsername("");
  };
  const passwordOnKeyPress = () => {
    setcognitoErrorPassword("");
  };

  function LoginModal() {
    useEffect(() => {
      setEmailTextIssue(cognitoErrorUsername);
      setPassTextIssue(cognitoErrorPassword);
    }, [cognitoErrorUsername, cognitoErrorPassword]);

    const handleOpen = () => {
      setOpen(true);
    };
    const handleClose = () => {
      setEmail("");
      setPassword("");
      setEmailTextIssue("");
      setPassTextIssue("");
      setOpen(false);
    };

    async function onClickLogin(event) {
      try {
        setLoading(true);
        const user = await Auth.signIn(email, password);

        console.log("user ", user);

        if (
          user.challengeName === "SMS_MFA" ||
          user.challengeName === "SOFTWARE_TOKEN_MFA"
        ) {
          //
        } else if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
          setResetPasswordOpenFirst(true);
          setOpen(false);
        } else if (user.challengeName === "MFA_SETUP") {
          //
        }

        const info = await Auth.currentUserInfo();
        let userdata = user.attributes;
        userdata.eid = user.username;
        userdata.id = info.id;
        setUser(JSON.stringify(userdata));
        userdata.sideactive = "/myPrograms";

        const bodyParam = {
          body: {
            oid: config.aws_org_id,
            eid: userdata.eid,
          },
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        };
        try {
          let response = await API.post(
            config.aws_cloud_logic_custom_name,
            Constants.GET_USER_PROGRESS,
            bodyParam
          );
          //alert("HIb "+JSON.stringify(response));
          userdata.data = response;
          //let encryptedString = cryptr.encrypt(JSON.stringify(userDetails));
          //dispatch(awsSignIn(userdata));
          //getEvents(UserProgressDetailsJSON);
          dispatch(awsSignIn(userdata));
          await localStorage.setItem("sessionStore", false);
          analyticsAPI(user);
          // if(idata != 0 && idata?.evbab){
          //   navigate("/applyProgram");
          // } else {
          navigate("/myPrograms");
          // }
        } catch (error) {
          //alert(JSON.stringify(error))
          console.error(error);
          dispatch(awsSignIn(userdata));
          await localStorage.setItem("sessionStore", false);
          navigate("/myPrograms");
        }
        //let encryptedString = cryptr.encrypt(JSON.stringify(userdata));
        // dispatch(awsSignIn(userdata));

        // navigate('/dashboard');
      } catch (error) {
        setLoading(false);
        if (error.code === "UserNotFoundException") {
          setEmailTextIssue("User does not exist");
        } else if (error.code === "UserNotConfirmedException") {
          setEmailTextIssue("User Not Confirmed");
        } else {
          setEmailTextIssue("");
        }
        if (error.code === "NotAuthorizedException") {
          setPassTextIssue("Invalid Password");
        } else {
          setPassTextIssue("");
        }
      }
    }

    async function analyticsAPI(datagot) {
      //console.log("lda ", datagot.attributes.sub);
      const bodyParam = {
        body: {
          oid: config.aws_org_id,
          id: datagot.attributes.id,
          eventtype: "AuthenticatedViaCognito",
          email: datagot.attributes.sub,
          emailid: datagot.attributes.email,
          name: datagot.attributes.name,
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      };
      try {
        const response = await API.post(
          config.aws_cloud_logic_custom_name,
          Constants.ANALYTICS_WEB_APP,
          bodyParam
          //`${Constants.GET_MY_PROGRAMS}`, bodyParam,
        );
      } catch (error) {
        console.log("getCategoryError", error);
      }
    }

    function setPasswordFocus(event) {
      if (event.key === "Tab") {
        clearEmail();
        passwordInput.current.focus();
      }
    }

    function validateEmail() {
      /* let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; */
      if (email === "" /* || re.test(email) */) {
        setEmailTextIssue("Please enter a valid email");
      } else {
        setEmailTextIssue("");
      }
    }

    function validatePass() {
      if (password === "") {
        setPassTextIssue("Please enter a password");
      } else {
        setPassTextIssue("");
      }
    }
    function getLoggedIn() {
      if (password !== "" && email !== "") {
        onClickLogin();
      }
    }

    function passwordClick(event) {
      if (event.key === "Enter") {
        validateEmail();
        validatePass();
        getLoggedIn();
      }
    }

    function loginClick() {
      console.log("text", emailTextIssue);
      console.log("textp", passTextIssue);

      validateEmail();
      validatePass();
      getLoggedIn();
    }
    function resetEmailPassIssueText(type) {
      if (type === 0) {
        setEmailTextIssue("");
      } else {
        setPassTextIssue("");
      }
    }

    return (
      <>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={open}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <div className={classes.paper}>
              {loading && (
                <CircularProgress className={appHeaderStyle.spinnerStyle} />
              )}
              <span
                style={{
                  float: "right",
                  cursor: "pointer",
                  fontSize: "large",
                  fontWeight: "bold",
                }}
                onClick={() => {
                  handleClose();
                }}
              >
                x
              </span>

              {il == "1" ? (
                <div style={{ display: "flex" }}>
                  <Image
                    size="small"
                    src={`https://${
                      Constants.DOMAIN
                    }/${config.aws_org_id.toLocaleLowerCase()}-resources/images/org-images/logo.jpg`}
                    style={{
                      margin: "2rem auto",
                      width: "200px",
                    }}
                  />
                  <Image
                    size="small"
                    src={logo}
                    style={{
                      marginTop: "5px",
                      marginBottom: "20px",
                      height: "100px",
                      width: "150px",
                    }}
                  />
                </div>
              ) : (
                <Image
                  size="small"
                  src={`https://${
                    Constants.DOMAIN
                  }/${config.aws_org_id.toLocaleLowerCase()}-resources/images/org-images/logo.jpg`}
                  style={{
                    margin: "2rem auto",
                    width: "200px",
                  }}
                />
              )}
              <p
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "18px",
                  color: "rgba(0, 0, 0, 0.6)",
                }}
              >
                Login to your account
              </p>
              <form className={classes.root} Validate autoComplete="off">
                <label className={appHeaderStyle.labelForIssue}>
                  {emailTextIssue}
                </label>
                <br />
                {/*  <EmailIcon  className={appHeaderStyle.emailIc}/> */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  <EmailIcon className={appHeaderStyle.emailIc} />
                  <TextField
                    style={{
                      width: "360px",
                    }} /* style={{ width: "350px", marginLeft: "90px", fontSize: "14px", position: "fixed", marginBottom: "10px", paddingLeft:"10px" }} */
                    className={classes.textBox}
                    type="text"
                    required
                    id="standard-required"
                    placeholder="User Name"
                    value={email}
                    onClick={() => {
                      resetEmailPassIssueText(0);
                    }}
                    onChange={(event) => setEmail(event.target.value)}
                    onKeyPress={(event) => {
                      emailOnKeyPress();
                      setPasswordFocus(event);
                    }}
                  ></TextField>
                </div>
                <br />

                <label className={appHeaderStyle.labelForIssue}>
                  {passTextIssue}
                </label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  {" "}
                  <Password className={appHeaderStyle.passIc} />
                  <TextField
                    style={{ width: "360px" }}
                    /* style={{ width: "350px", marginLeft: "90px", marginTop: "0px", marginBottom: "10px", }} */
                    className={classes.textBox}
                    placeholder="Password"
                    type="password"
                    autoComplete="current-password"
                    value={password}
                    onClick={() => {
                      resetEmailPassIssueText(1);
                    }}
                    onChange={(event) => setPassword(event.target.value)}
                    onKeyPress={(event) => {
                      passwordOnKeyPress();
                      passwordClick(event);
                    }}
                  />
                </div>
                <br />
                <a
                  href
                  className={classes.forgotPW}
                  onClick={() => {
                    forgotPasswordSwap();
                  }}
                >
                  Forgot password?
                </a>
                <br />
                <br />
                <input
                  type="button"
                  style={{
                    backgroundColor: "#3372B5",
                    color: "white",
                    height: "34px",
                    width: "110px",
                    borderRadius: "3px",
                    border: "none",
                    fontWeight: "bold",
                    fontSize: "15px",
                  }}
                  onClick={() => {
                    loginClick();
                  }}
                  value="Login"
                />
                <br />

                <input
                  type="button"
                  style={{
                    backgroundColor: "white",
                    color: "#3372B5",
                    height: "34px",
                    width: "110px",
                    borderRadius: "3px",
                    marginTop: "20px",
                    fontWeight: "bold",
                    fontSize: "15px",
                    borderColor: "#3372B5",
                  }}
                  value="SignUp"
                  onClick={() => {
                    openSignIn();
                  }}
                />
                <div
                  style={{
                    alignItems: "center",
                    fontSize: "16px",
                    fontWeight: "bold",
                    color: "black",
                    marginTop: "18px",
                  }}
                >
                  <a
                    target="_blank"
                    href="https://d1fgflxnncw0ta.cloudfront.net/admin/index.html"
                  >
                    Click here to login as Admin
                  </a>
                </div>
                {/* <div style={{alignItems:"center",fontSize:"16px", fontWeight:"bold",  color: "black",marginLeft:"167px",marginTop:"18px" }}>
                 <a target="_blank" href="https://www.jssoepdev.enhanzed.com/admin/index.html">Click here to login as Teacher</a></div> */}
              </form>
            </div>
          </Fade>
        </Modal>
      </>
    );
  }

  let SignInModal = () => {
    useEffect(() => {
      setRegEmailTextIssue(regCognitoErrorUsername);
      setRegPassTextIssue(regCognitoErrorPassword);
    }, [regCognitoErrorUsername, regCognitoErrorPassword]);

    const nameOnKeyPress = () => {};

    const emailOnKeyPress = () => {};

    const passwordOnKeyPress = () => {};

    const confirmPasswordOnKeyPress = () => {};

    const handleOpen = () => {
      setSignInOpen(true);
    };
    const handleClose = () => {
      setSignInOpen(false);
      openLogin();
      setName("");
      setRegEmail("");
      setRegPassword("");
      setRegConfirmPassword("");
    };
    const onClickRegister = async () => {
      try {
        setLoading(true);

        const signUpResponse = await Auth.signUp({
          username: regEmail.toLowerCase(),
          password: regPassword,
          attributes: {
            email: regEmail,
            name: name,
          },
        });
        if (signUpResponse) {
          swal(
            "Registered Succesfully.Please check your email & click Verify Email link to verify your email. \n Then try to login!"
          );
          setLoading(false);
          setName("");
          setRegEmail("");
          setRegPassword("");
          setRegConfirmPassword("");
          handleClose();
        }
      } catch (error) {
        console.log("err", error);
        setLoading(false);
        if (error.code === "InvalidParameterException") {
          setRegCognitoErrorPassword("Password must be at least 8 characters");
        } else {
          setRegCognitoErrorPassword("");
        }
        if (error.code === "UsernameExistsException") {
          setRegCognitoErrorUsername(
            "An account with the given email already exists."
          );
        } else if (error.message === "Invalid email address format.") {
          setRegCognitoErrorUsername("Invalid email address format.");
        } else {
          setRegCognitoErrorUsername("");
        }
      }
    };
    function setRegPasswordFocus(event) {
      if (event.key === "Tab") {
        passwordInput.current.focus();
      }
    }

    function validateEmail() {
      const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
      const format1 = /[ 1234567890]/;
      const format2 = /[ abcdefghijklmnopqrstuvwxyz]/;
      var reg = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      const re = /^\S+@\S+$/;
      if (regEmail === "" || !reg.test(regEmail)) {
        setRegEmailTextIssue("Please enter a valid email");
      } else {
        setRegEmailTextIssue("");
      }
    }

    function validatePass() {
      if (regPassword === "") {
        setRegPassTextIssue("Please enter a password");
      } else {
        setRegPassTextIssue("");
      }
    }
    function validateName() {
      if (name === "") {
        setRegNameTextIssue("Please enter a Name");
      } else {
        setRegNameTextIssue("");
      }
    }
    function samePassVerify() {
      if (regConfirmPassword === "") {
        setRegConfrimPassTextIssue("Please enter a password");
      } else {
        setRegConfrimPassTextIssue("");
      }
      if (regPassword !== regConfirmPassword) {
        setRegConfrimPassTextIssue("Passwords don't Match!");
      } else {
        setRegConfrimPassTextIssue("");
      }
    }
    function getSignedUp() {
      if (
        regPassword !== "" &&
        regEmail !== "" &&
        regConfirmPassword !== "" &&
        name !== ""
      ) {
        onClickRegister();
      }
    }

    function passwordClick(event) {
      if (event.key === "Enter") {
        validateName();
        validateEmail();
        validatePass();
        samePassVerify();
        getSignedUp();
      }
    }
    function confirmPasswordClick(event) {
      if (event.key === "Enter") {
        validateName();
        validateEmail();
        validatePass();
        samePassVerify();
        getSignedUp();
      }
    }

    function registerClick() {
      validateName();
      validateEmail();
      validatePass();
      samePassVerify();
      getSignedUp();
    }

    function resetEmailPassIssueText(type) {
      if (type === 0) {
        setRegEmailTextIssue("");
      } else {
        setRegPassTextIssue("");
      }
    }

    async function checkIlearn() {
      // localStorage.setItem("eVBAB", false);
      const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
      const format1 = /[ 1234567890]/;
      const format2 = /[ abcdefghijklmnopqrstuvwxyz]/;
      var reg = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      const re = /^\S+@\S+$/;
      if (regEmail === "" || !reg.test(regEmail)) {
        setRegEmailTextIssue("Please enter a valid email");
        return;
      } else {
        setRegEmailTextIssue("");
      }

      setLoading(true);
      const bodyParam = {
        body: { emailid: regEmail },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      };

      try {
        const response = await API.post(
          config.aws_cloud_logic_custom_name,
          Constants.GCP_RESPONSE,
          bodyParam
          //`${Constants.GET_MY_PROGRAMS}`, bodyParam,
        );

        let json = JSON.stringify(response);

        let presonse = json.toString();

        presonse = JSON.parse(presonse);
        setLoading(false);
        // alert(presonse);
        try {
          presonse = presonse.replace(")]}'", "");
          presonse = JSON.parse(presonse);
          console.log(presonse);
          var msg = JSON.parse(presonse.payload);
          console.log(msg);
          if (msg.message != "Successful") {
            swal(
              "To apply for scholarship, you need to register in the  https://ilearn.gov.in iLearn portal first"
            );
            // swal({
            //     html:
            //     '<p style="color:#484848">To apply for scholarship,<br> you need to register in the  <a href="https://ilearn.gov.in" target="_blank">iLearn portal</a> first</p>',
            //     // text: "To apply for scholarship, you need to register in the iLearn portal first",
            // type: "warning", width: '400px',
            // showConfirmButton: true, confirmButtonText: 'Ok', confirmButtonColor: "#E77C2D" });
            // $scope.drpscholarship.drpval = 'No';
          } else {
            setName(msg.first_name + " " + msg.last_name);
            let obj = {};
            if (idata != 0 && pid && il) {
              obj = {
                ...idata,
                evbab: true,
                pid: pid,
                il: il,
              };
              dispatch(setIL(obj));
            } else if (pid && il) {
              obj = {
                pid: pid,
                evbab: true,
                il: il,
              };
              dispatch(setIL(obj));
            }
            setIls(false);
            // alert("Got Data");
          }
        } catch (err) {
          swal(
            "To apply for scholarship, you need to register in the  https://ilearn.gov.in iLearn portal first"
          );
        }
        // getprofileresponse(ptoken.token);
      } catch (error) {
        console.log("checkIlearn", error);
      }
    }

    return (
      <>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={signInOpen}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={signInOpen}>
            <div className={classes.SignInPaper}>
              <span
                style={{
                  float: "right",
                  cursor: "pointer",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
                onClick={() => {
                  handleClose();
                }}
              >
                X
              </span>
              {loading && (
                <CircularProgress className={appHeaderStyle.spinnerStyle} />
              )}

              {il == "1" ? (
                <div style={{ display: "flex" }}>
                  <Image
                    size="small"
                    src={`https://${
                      Constants.DOMAIN
                    }/${config.aws_org_id.toLocaleLowerCase()}-resources/images/org-images/logo.jpg`}
                    style={{
                      margin: "2rem auto",
                      width: "200px",
                    }}
                  />
                  <Image
                    size="small"
                    src={logo}
                    style={{
                      marginTop: "5px",
                      // marginBottom: "50px",
                      height: "100px",
                      width: "150px",
                    }}
                  />
                </div>
              ) : (
                <Image
                  size="small"
                  src={`https://${
                    Constants.DOMAIN
                  }/${config.aws_org_id.toLocaleLowerCase()}-resources/images/org-images/logo.jpg`}
                  style={{
                    margin: "2rem auto",
                    width: "200px",
                  }}
                />
              )}
              {false ? (
                <>
                  <label className={appHeaderStyle.labelForIssue}>
                    {regEmailTextIssue}
                  </label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                    }}
                  >
                    <EmailIcon className={appHeaderStyle.emailIc} />
                    <TextField
                      style={{
                        width: "360px",
                      }}
                      className={classes.textBox}
                      type="text"
                      required
                      id="standard-required"
                      placeholder="Email"
                      value={regEmail}
                      onChange={(e) => setRegEmail(e.target.value)}
                      onClick={() => {
                        resetEmailPassIssueText(0);
                      }}
                      onKeyPress={(event) => {
                        if (event.key === "Enter") {
                          checkIlearn();
                        }
                      }}
                    />
                  </div>

                  <input
                    type="button"
                    style={{
                      backgroundColor: "white",
                      marginTop: "20px",
                      marginBottom: "10px",
                      color: "#3372B5",
                      height: "30px",
                      width: "80px",
                      borderRadius: "3px",
                      borderColor: "#3372B5",
                      fontWeight: "bold",
                      fontSize: "15px",
                    }}
                    onClick={() => {
                      checkIlearn();
                    }}
                    value="Verify"
                  />
                </>
              ) : (
                <form
                  /* onSubmit={handleSubmit(onSubmit)} */ className={
                    classes.root
                  }
                  Validate
                  autoComplete="off"
                >
                  <label className={appHeaderStyle.labelForIssue}>
                    {regNameTextIssue}
                  </label>
                  <br />
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                    }}
                  >
                    <EmailIcon className={appHeaderStyle.emailIc} />
                    <TextField
                      style={{
                        width: "360px",
                      }}
                      className={classes.textBox}
                      type="text"
                      required
                      id="standard-required"
                      placeholder="Name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      onKeyPress={nameOnKeyPress}
                    />
                  </div>
                  <label className={appHeaderStyle.labelForIssue}>
                    {regEmailTextIssue}
                  </label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                    }}
                  >
                    <EmailIcon className={appHeaderStyle.emailIc} />
                    <TextField
                      style={{
                        width: "360px",
                      }}
                      className={classes.textBox}
                      type="text"
                      required
                      id="standard-required"
                      placeholder="Email"
                      value={regEmail}
                      onChange={(e) => setRegEmail(e.target.value)}
                      onClick={() => {
                        resetEmailPassIssueText(0);
                      }}
                      onKeyPress={(event) => {
                        emailOnKeyPress();
                        setRegPasswordFocus(event);
                      }}
                    />
                  </div>
                  <label className={appHeaderStyle.labelForIssue}>
                    {regPassTextIssue}
                  </label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                    }}
                  >
                    <Password className={appHeaderStyle.passIc} />
                    <TextField
                      style={{
                        width: "360px",
                      }}
                      className={classes.textBox}
                      id="standard-password-input"
                      type="password"
                      placeholder="Password"
                      autoComplete="current-password"
                      value={regPassword}
                      onClick={() => {
                        resetEmailPassIssueText(1);
                      }}
                      onChange={(e) => setRegPassword(e.target.value)}
                      onKeyPress={(event) => {
                        passwordOnKeyPress();
                        passwordClick(event);
                      }}
                    />
                  </div>
                  <label className={appHeaderStyle.labelForIssue}>
                    {regConfirmpassTextIssue}
                  </label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                    }}
                  >
                    <Password className={appHeaderStyle.passIc} />
                    <TextField
                      style={{
                        width: "360px",
                      }}
                      className={classes.textBox}
                      id="standard-password-input"
                      placeholder="Confirm Password"
                      type="password"
                      autoComplete="current-password"
                      value={regConfirmPassword}
                      onClick={() => {
                        resetEmailPassIssueText(1);
                      }}
                      onChange={(e) => setRegConfirmPassword(e.target.value)}
                      onKeyPress={(event) => {
                        confirmPasswordOnKeyPress();
                        confirmPasswordClick(event);
                      }}
                    />
                  </div>
                  <p className={classes.noteText}>
                    *Password should be at least 8 characters, contain at least
                    one lowercase letter & one number & one special character.
                  </p>
                  <br />
                  <input
                    type="button"
                    style={{
                      backgroundColor: "white",
                      marginTop: "20px",
                      color: "#3372B5",
                      height: "30px",
                      width: "80px",
                      borderRadius: "3px",
                      borderColor: "#3372B5",
                      fontWeight: "bold",
                      fontSize: "15px",
                    }}
                    onClick={() => {
                      registerClick();
                    }}
                    value="SignUp"
                  />
                  <br />
                </form>
              )}
              <br />
              <div
                style={{
                  cursor: "pointer",
                  textAlign: "center",
                  fontSize: "16px",
                }}
                onClick={() => {
                  openLogin();
                }}
              >
                Already have an account?{" "}
                <span style={{ color: "#3372B5", fontWeight: "700" }}>
                  Login
                </span>
              </div>
              {il == "1" ? (
                <div
                  style={{
                    padding: "12px",
                    textAlign: "justify",
                    border: "1px solid black",
                  }}
                >
                  The Government of India offers 100% Scholarship to students
                  from partner African Countries through e-VidyBharati and
                  e-ArogyaBharati (e-VBAB) Network Project to pursue ONLINE
                  Undergraduate, Postgrauate, Diploma and Certificate programmes
                  from various reputed Indian Universities/ Institutes in
                  various disciplines including computer application, business
                  administration and commerce, healthcare, tourism, humanities
                  and arts etc.
                </div>
              ) : null}
            </div>
          </Fade>
        </Modal>
      </>
    );
  };
  let ForgotPasswordModal = () => {
    useEffect(() => {
      setForgotPasswordEmailTextIssue(forgotPasswordCognitoErrorUsername);
    }, [forgotPasswordCognitoErrorUsername]);

    const emailOnKeyPress = () => {};

    const forgotPasswordHandler = async () => {
      try {
        setLoading(true);
        /*  setResetPasswordOpen(true); */
        const forgot = await Auth.forgotPassword(forgotPasswordEmail);
        if (forgot) {
          setResetPasswordOpen(true);
          setOpen(false);
          //setForgotPasswordEmail("");
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        if (error.code === "UserNotFoundException") {
          setForgotPasswordCognitoErrorUsername("User does not exist");
        } else {
          setForgotPasswordCognitoErrorUsername("");
        }
      }
      /*   setResetPasswordOpen(true);
      setOpen(false); */
    };

    function validateEmail() {
      if (forgotPasswordEmail === "") {
        setForgotPasswordEmailTextIssue("Please enter a valid email");
      } else {
        setForgotPasswordEmailTextIssue("");
      }
    }
    function getForgotPass() {
      if (forgotPasswordEmail !== "") {
        forgotPasswordHandler();
      }
    }

    function forgotClick() {
      validateEmail();
      getForgotPass();
    }

    function resetEmailPassIssueText(type) {
      if (type === 0) {
        setForgotPasswordEmailTextIssue("");
      }
    }

    const handleOpen = () => {
      setForgotPasswordOpen(true);
    };
    const handleClose = () => {
      setForgotPasswordOpen(false);
      setOpen(true);
      setForgotPasswordEmail("");
      setForgotPasswordEmailTextIssue("");
    };

    return (
      <>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={forgotPasswordOpen}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={forgotPasswordOpen}>
            <div className={classes.forgotPasswordPaper}>
              <span
                style={{
                  float: "right",
                  cursor: "pointer",
                  fontSize: "large",
                  fontWeight: "bold",
                }}
                onClick={() => {
                  handleClose();
                }}
              >
                x
              </span>
              {loading && (
                <CircularProgress className={appHeaderStyle.spinnerStyle} />
              )}
              <Image
                size="small"
                src={`https://${
                  Constants.DOMAIN
                }/${config.aws_org_id.toLocaleLowerCase()}-resources/images/org-images/logo.jpg`}
                style={{
                  margin: "2rem auto",
                  width: "200px",
                }}
              />
              <form
                /* onSubmit={handleSubmit(onSubmit)} */ className={classes.root}
                Validate
                autoComplete="off"
              >
                <label className={appHeaderStyle.labelForIssue}>
                  {forgotPasswordEmailTextIssue}
                </label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  <EmailIcon className={appHeaderStyle.emailIc} />
                  <TextField
                    style={{
                      width: "360px",
                    }}
                    className={classes.textBox}
                    type="text"
                    required
                    id="standard-required"
                    placeholder="Email"
                    value={forgotPasswordEmail}
                    onChange={(e) => setForgotPasswordEmail(e.target.value)}
                    onClick={() => {
                      resetEmailPassIssueText(0);
                    }}
                    //onKeyPress={(event) => { emailOnKeyPress(); }}
                  />
                </div>

                <br />

                <input
                  type="button"
                  style={{
                    backgroundColor: "#3372B5",
                    color: "white",
                    height: "30px",
                    width: "80px",
                    borderRadius: "3px",
                    marginTop: "10px",
                    border: "none",
                    fontSize: "15px",
                  }}
                  onClick={() => {
                    forgotClick();
                  }}
                  value="Next"
                />
              </form>
            </div>
          </Fade>
        </Modal>
      </>
    );
  };
  let ResetPasswordModal = () => {
    useEffect(() => {
      setResetPassVerificationCode(resetPasswordCodeIssue);
    }, [resetPasswordCodeIssue]);

    function resetHandler() {
      if (verificationCode === "") {
        setResetPassVerificationCode("Please enter the code");
        return;
      } else if (resetPassword === "") {
        setResetPasswordMatch("Please enter a password");
        return;
      } else if (confirmResetPassword === "") {
        setResetPasswordMatch("Please enter a confirm password");
        return;
      } else {
        samePassVerify();
      }
    }
    const passwordVerificationHandler = async (event) => {
      try {
        setLoading(true);
        await Auth.forgotPasswordSubmit(
          forgotPasswordEmail,
          verificationCode,
          resetPassword
        );

        swal("Changed password Succesfully");
        setLoading(false);
        setResetPasswordOpen(false);
        setForgotPasswordOpen(false);
        setOpen(true);
        setVerificationCode("");
        setResetPassword("");
        setConfirmResetPassword("");
        setResetPassVerificationCode("");
        setResetPasswordCodeIssue("");
        setResetPasswordMatch("");
        setForgotPasswordEmail("");
      } catch (error) {
        setLoading(false);
        console.log("err", error);
        if (error.code === "InvalidParameterException") {
          setResetPasswordCodeIssue("Invalid code entered");
        } else {
          setResetPasswordCodeIssue("");
        }
        if (error.code === "CodeMismatchException") {
          setResetPasswordCodeIssue("Code mismatch");
        } else if (error.code === "InvalidPasswordException") {
          setResetPasswordCodeIssue("Please match the password type.");
        } else {
          setResetPasswordCodeIssue("");
        }
      }
    };

    const passwordOnKeyPress = () => {};

    const VerificationcodeOnKeyPress = () => {};
    const handleOpen = () => {
      setResetPasswordOpen(true);
    };
    const handleClose = () => {
      setResetPasswordOpen(false);
      setVerificationCode("");
      setResetPassword("");
      setConfirmResetPassword("");
      setResetPassVerificationCode("");
      setResetPasswordCodeIssue("");
      setResetPasswordMatch("");
    };

    function samePassVerify() {
      var regularExpression =
        /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,16}$/;
      if (resetPassword === "") {
        setResetPasswordMatch("Please enter a password");
      } else {
        setResetPasswordMatch("");
      }

      if (confirmResetPassword === "") {
        setResetPasswordMatch("Please enter a password");
      } else {
        setResetPasswordMatch("");
      }
      if (resetPassword !== confirmResetPassword) {
        setResetPasswordMatch("Passwords don't Match!");
      } else {
        setResetPasswordMatch("");
      }
      if (!regularExpression.test(resetPassword)) {
        setResetPasswordMatch("Please match password pattern");
      } else {
        setResetPasswordMatch("");
      }
      passwordVerificationHandler();
    }
    return (
      <>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={resetPasswordOpen}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={resetPasswordOpen}>
            <div className={classes.ResetPasswordPaper}>
              <span
                style={{ float: "right", cursor: "pointer" }}
                onClick={() => {
                  handleClose();
                }}
              >
                x
              </span>
              {loading && (
                <CircularProgress className={appHeaderStyle.spinnerStyle} />
              )}
              <Image
                size="small"
                src={`https://${
                  Constants.DOMAIN
                }/${config.aws_org_id.toLocaleLowerCase()}-resources/images/org-images/logo.jpg`}
                style={{
                  margin: "2rem auto",
                  width: "200px",
                }}
              />
              <p
                style={{
                  textAlign: "center",
                  fontSize: "16px",
                  color: "rgba(0, 0, 0, 0.6)",
                }}
              >
                Password Reset
              </p>
              <p
                style={{
                  textAlign: "center",
                  fontSize: "14px",
                  color: "rgba(0, 0, 0, 0.6)",
                }}
              >
                {" "}
                Please enter the verification code sent to your email
              </p>
              <br />
              <form
                /* onSubmit={handleSubmit(onSubmit)} */ className={classes.root}
                Validate
                autoComplete="off"
              >
                <label className={appHeaderStyle.labelForIssue}>
                  {resetPassVerificationCode}
                </label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  <TextField
                    style={{ width: "360px" }}
                    /* style={{ width: "350px", marginLeft: "90px", marginTop: "0px", marginBottom: "10px", }} */
                    className={classes.textBox}
                    type="text"
                    required
                    id="standard-required"
                    value={verificationCode}
                    placeholder={"Verification Code"}
                    onChange={(e) => setVerificationCode(e.target.value)}
                    onKeyPress={VerificationcodeOnKeyPress}
                    autocomplete="off"
                    //onKeyPress={nameOnKeyPress}
                  />
                </div>
                <label className={appHeaderStyle.labelForIssue}>
                  {resetPasswordMatch}
                </label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  {" "}
                  <Password className={appHeaderStyle.passIc} />
                  <TextField
                    style={{ width: "360px" }}
                    /* style={{ width: "350px", marginLeft: "90px", marginTop: "0px", marginBottom: "10px", }} */
                    className={classes.textBox}
                    type="password"
                    required
                    id="standard-required"
                    value={resetPassword}
                    autocomplete="off"
                    placeholder={"New password"}
                    onChange={(e) => setResetPassword(e.target.value)}
                    onKeyPress={passwordOnKeyPress}
                    //onKeyPress={nameOnKeyPress}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  {" "}
                  <Password className={appHeaderStyle.passIc} />
                  <TextField
                    style={{ width: "360px" }}
                    /* style={{ width: "350px", marginLeft: "90px", marginTop: "0px", marginBottom: "10px", }} */
                    className={classes.textBox}
                    type="password"
                    required
                    id="standard-required"
                    value={confirmResetPassword}
                    placeholder={"Confirm password"}
                    onChange={(e) => setConfirmResetPassword(e.target.value)}
                    onKeyPress={VerificationcodeOnKeyPress}
                    //onKeyPress={nameOnKeyPress}
                  />
                </div>
                <p
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    margin: "auto",
                    padding: "0rem 1rem",
                    color: "rgba(0, 0, 0, 0.4)",
                  }}
                >
                  *Password should be at least 8 characters, contain at least
                  one lowercase letter & one number & one special character.
                </p>
                <br /> <br />
                <input
                  type="button"
                  onClick={() => {
                    resetHandler();
                  }}
                  style={{
                    backgroundColor: "#3372B5",
                    color: "white",
                    height: "30px",
                    width: "100px",
                    borderRadius: "3px",
                    border: "none",
                    fontWeight: "bold",
                    fontSize: "15px",
                  }}
                  value="Submit"
                />
              </form>
            </div>
          </Fade>
        </Modal>
      </>
    );
  };

  function ResetPasswordModalFirstTime() {
    useEffect(() => {
      setResetPassVerificationCodeFirst(resetPasswordCodeIssue);
    }, [resetPasswordCodeIssue]);

    function resetHandlerFirst() {
      samePassVerifyFirst();
    }
    const passwordVerificationHandlerFirst = async (event) => {
      try {
        setLoading(true);
        await Auth.signIn(email, password).then((users) => {
          if (users.challengeName === "NEW_PASSWORD_REQUIRED") {
            Auth.completeNewPassword(users, confirmResetPasswordFirst);
          }
        });

        swal("Changed password Succesfully");
        setLoading(false);
        setResetPasswordOpen(false);
        setForgotPasswordOpen(false);
        setOpen(true);
        setPassword("");

        setResetPasswordFirst("");
        setConfirmResetPasswordFirst("");

        setResetPasswordCodeIssueFirst("");
        setResetPasswordMatchFirst("");
      } catch (error) {
        setLoading(false);
        console.log("err", error);
        if (error.code === "InvalidParameterException") {
          setResetPasswordCodeIssue("Invalid code entered");
        } else {
          setResetPasswordCodeIssue("");
        }
        if (error.code === "CodeMismatchException") {
          setResetPasswordCodeIssue("Code mismatch");
        } else if (error.code === "InvalidPasswordException") {
          setResetPasswordCodeIssue("Please match the password type.");
        } else {
          setResetPasswordCodeIssue("");
        }
      }
    };

    const passwordOnKeyPress = () => {};

    const VerificationcodeOnKeyPress = () => {};
    const handleOpen = () => {
      setResetPasswordOpen(true);
    };
    const handleClose = () => {
      setResetPasswordOpen(false);
      setResetPasswordOpenFirst(false);
      setVerificationCode("");
      setResetPassword("");
      setConfirmResetPassword("");
      setResetPassVerificationCode("");
      setResetPasswordCodeIssue("");
      setResetPasswordMatch("");
      setResetPasswordMatchFirst("");
      setPassword("");
      setEmail("");
      setResetPasswordFirst("");
      setConfirmResetPasswordFirst("");
    };

    function samePassVerifyFirst() {
      var regularExpression =
        /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,16}$/;

      if (resetPasswordFirst === "") {
        setResetPasswordMatchFirst("Please enter a password");
        return;
      }
      if (confirmResetPasswordFirst === "") {
        setResetPasswordMatchFirst("Please enter a confirm password");
        return;
      }
      if (resetPasswordFirst !== confirmResetPasswordFirst) {
        setResetPasswordMatchFirst("Passwords don't Match!");
        return;
      }
      if (!regularExpression.test(resetPasswordFirst)) {
        setResetPasswordMatchFirst("Please match password pattern");
        return;
      }
      passwordVerificationHandlerFirst();
    }
    return (
      <>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={resetPasswordOpenFirst}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={resetPasswordOpenFirst}>
            <div className={classes.ResetPasswordPaperFirst}>
              <span
                style={{ float: "right", cursor: "pointer" }}
                onClick={() => {
                  handleClose();
                }}
              >
                x
              </span>
              {loading && (
                <CircularProgress className={appHeaderStyle.spinnerStyle} />
              )}
              <Image
                size="small"
                src={`https://${
                  Constants.DOMAIN
                }/${config.aws_org_id.toLocaleLowerCase()}-resources/images/org-images/logo.jpg`}
                style={{ margin: "2rem auto", width: "200px" }}
              />
              <p
                style={{
                  textAlign: "center",
                  fontSize: "16px",
                  color: "rgba(0, 0, 0, 0.6)",
                }}
              >
                Password Reset
              </p>
              <p
                style={{
                  textAlign: "center",
                  fontSize: "14px",
                  color: "rgba(0, 0, 0, 0.6)",
                }}
              >
                {" "}
                Please complete reset password
              </p>
              <br />
              <form
                /* onSubmit={handleSubmit(onSubmit)} */ className={classes.root}
                Validate
                autoComplete="off"
              >
                <label className={appHeaderStyle.labelForIssue}>
                  {resetPasswordMatchFirst}
                </label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  {" "}
                  <Password className={appHeaderStyle.passIc} />
                  <TextField
                    style={{ width: "360px" }}
                    /* style={{ width: "350px", marginLeft: "90px", marginTop: "0px", marginBottom: "10px", }} */
                    className={classes.textBox}
                    type="password"
                    required
                    id="standard-required"
                    value={resetPasswordFirst}
                    autocomplete="off"
                    placeholder={"New password"}
                    onChange={(e) => setResetPasswordFirst(e.target.value)}
                    onKeyPress={passwordOnKeyPress}
                    //onKeyPress={nameOnKeyPress}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  {" "}
                  <Password className={appHeaderStyle.passIc} />
                  <TextField
                    style={{ width: "360px" }}
                    /* style={{ width: "350px", marginLeft: "90px", marginTop: "0px", marginBottom: "10px", }} */
                    className={classes.textBox}
                    type="password"
                    required
                    id="standard-required"
                    value={confirmResetPasswordFirst}
                    placeholder={"Confirm password"}
                    onChange={(e) =>
                      setConfirmResetPasswordFirst(e.target.value)
                    }
                    onKeyPress={VerificationcodeOnKeyPress}
                    //onKeyPress={nameOnKeyPress}
                  />
                </div>
                <p
                  style={{
                    fontSize: "10px",
                    width: "360px",
                    textAlign: "center",
                    marginLeft: "90px",
                    color: "rgba(0, 0, 0, 0.4)",
                  }}
                >
                  *Password should be at least 8 characters, contain one number
                  & one special character.
                </p>
                <br /> <br />
                <input
                  type="button"
                  onClick={() => {
                    resetHandlerFirst();
                  }}
                  style={{
                    backgroundColor: "#3372B5",
                    marginLeft: "220px",
                    color: "white",
                    height: "30px",
                    width: "100px",
                    borderRadius: "3px",
                    border: "none",
                    fontWeight: "bold",
                    fontSize: "15px",
                  }}
                  value="Submit"
                />
              </form>
            </div>
          </Fade>
        </Modal>
      </>
    );
  }

  function toNavigate(item) {
    localStorage.setItem("bpid", item.bpid);
    localStorage.setItem("pid", item.pid);
    navigate("/myProg/" + item.pid + "/0");
    window.location.reload();
  }
  return (
    <div>
      {LoginModal()}
      {SignInModal()}
      {ForgotPasswordModal()}
      {ResetPasswordModal()}
      {ResetPasswordModalFirstTime()}
      <Menu secondary fixed="top" className={appHeaderStyle.headerStyle}>
        <div className={classes.logoResponsiveMobileContainer}>
          <MenuIcon
            className={classes.headerIcon}
            onClick={toggleDrawer("left", true)}
          />
          <SwipeableDrawer
            anchor={"left"}
            open={drawerState}
            onClose={toggleDrawer("left", false)}
            onOpen={toggleDrawer("left", true)}
          >
            {DrawerList("left")}
          </SwipeableDrawer>
        </div>

        <div className={classes.logoResponsiveContainer}>
          <a href="https://jssuni.edu.in/JSSWeb/WebHome.aspx" target="_blank">
            <Image
              size="small"
              src={`https://${
                Constants.DOMAIN
              }/${config.aws_org_id.toLocaleLowerCase()}-resources/images/org-images/logo.jpg`}
              className={classes.logoResponsive}
            />
          </a>
          {il == "1" ? (
            <Image size="small" src={logo} className={classes.logoResponsive} />
          ) : null}
        </div>
        <div className={classes.mainMenu} style={{ margin: "2rem" }}>
          {/* <div style={{color:"white",fontSize:"18px",marginTop: "-19px",padding:"0px 12px"}}>
          <a style={{color:"white",fontSize:"18px",padding:"0px 12px",textDecoration:"none",fontWeight:"bolder"}} 
           target="_blank"  rel="noreferrer" href={`https://${
                      Constants.DOMAIN
                    }/${config.aws_org_id.toLowerCase()}-resources/ugc/UGC_APPROVED_JSS.pdf`}>
                     <Image
              size="small"
              src={`https://${
                Constants.DOMAIN
              }/${config.aws_org_id.toLocaleLowerCase()}-resources/ugc/ugc_logo.png`}
              style={{ marginRight: "1.5em", height: "55px", width: "100%" }}
            /></a>
        </div> */}

          {/* <div style={{color:"white",fontSize:"18px",marginTop: "20px",padding:"0px 12px"}}>
          <a style={{color:"white",fontSize:"18px",marginTop: "20px",padding:"0px 12px",textDecoration:"none",fontWeight:"bolder"}} 
           target="_blank"  rel="noreferrer" href={`https://marvelapp.com/prototype/8ga9h23`}>Walkthrough of LMS</a>  
        </div> */}

          {/* <Menu.Item
          as="a"
          position="right"
          header
          style={{ color: "white" }}
        ></Menu.Item> */}
          {/* <Menu.Item
          as="a"
          href="http://www.infoblog.jssuni.edu.in/"
          target="_blank"
          style={{ color: "white" }}
        >
          Research forum
        </Menu.Item> */}

          <Dropdown
            icon="dropdown"
            text="About"
            style={{ float: "right", color: "white" }}
            position="right"
            className="link item"
          >
            <Dropdown.Menu>
              <Link
                to={`/aboutJssaher`}
                style={{ color: "white", marginTop: "12px" }}
              >
                {" "}
                <Dropdown.Item>JSSAHER</Dropdown.Item>
              </Link>
              <Link
                to={`/aboutOEP`}
                style={{ color: "white", marginTop: "12px" }}
              >
                {" "}
                <Dropdown.Item>Online Learning</Dropdown.Item>
              </Link>
            </Dropdown.Menu>
          </Dropdown>
          <Dropdown
            className="link item"
            text="Programs"
            style={{ color: "white" }}
          >
            <Dropdown.Menu>
              {/* <Dropdown className="link item" text="PG Diploma">
              {pgDiplomaData.length === 0 ? (
                <div></div>
              ) : (
                <Dropdown.Menu>
                  {pgDiplomaData.map((item) => (
                    <Dropdown.Item onClick={() => toNavigate(item)}>
                      <p dangerouslySetInnerHTML={{ __html: item.pname }}></p>
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              )}
            </Dropdown> */}
              <Dropdown className="link item" text="Post Graduate">
                {graduateData.length === 0 ? (
                  <div></div>
                ) : (
                  <Dropdown.Menu>
                    {graduateData.map((item) => (
                      <Dropdown.Item onClick={() => toNavigate(item)}>
                        <p dangerouslySetInnerHTML={{ __html: item.pname }}></p>
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                )}
              </Dropdown>
              <Dropdown className="link item" text="Under Graduate">
                {underGraduateData.length === 0 ? (
                  <div></div>
                ) : (
                  <Dropdown.Menu>
                    {underGraduateData.map((item) => (
                      <Dropdown.Item onClick={() => toNavigate(item)}>
                        <p dangerouslySetInnerHTML={{ __html: item.pname }}></p>
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                )}
              </Dropdown>
              <Dropdown className="link item" text="Diploma">
                {diplomaData.length === 0 ? (
                  <div></div>
                ) : (
                  <Dropdown.Menu>
                    {diplomaData.map((item) => (
                      <Dropdown.Item onClick={() => toNavigate(item)}>
                        <p dangerouslySetInnerHTML={{ __html: item.pname }}></p>
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                )}
              </Dropdown>
              <Dropdown className="link item" text="Certificate">
                {certificateData.length === 0 ? (
                  <div></div>
                ) : (
                  <Dropdown.Menu>
                    {certificateData.map((item) => (
                      <Dropdown.Item onClick={() => toNavigate(item)}>
                        <p dangerouslySetInnerHTML={{ __html: item.pname }}></p>
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                )}
              </Dropdown>

              <Dropdown className="link item" text="Doctor Of Pharmacy">
                {certificateData.length === 0 ? (
                  <div></div>
                ) : (
                  <Dropdown.Menu>
                    {certificateData.map((item) => (
                      <Dropdown.Item onClick={() => toNavigate(item)}>
                        <p dangerouslySetInnerHTML={{ __html: item.pname }}></p>
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                )}
              </Dropdown>
            </Dropdown.Menu>
          </Dropdown>

          {/* <Dropdown
          className="link item"
          text="Admissions"
          style={{ color: "white" }}
        >
          <Dropdown.Menu>
            <Link
              to={`/onlineProgram`}
              style={{ color: "white", marginTop: "12px" }}
            >
              {" "}
              <Dropdown.Item>Online Program</Dropdown.Item>
            </Link>
          </Dropdown.Menu>
        </Dropdown> */}
          {/* <Menu.Item
          as="a"
          href="http://www.infoblog.jssuni.edu.in/"
          target="_blank"
          style={{ color: "white" }}
        >
          Research forum
        </Menu.Item> */}
          <Link
            to={`/contactUs`}
            style={{
              color: "white",
              textDecoration: "none",
            }}
          >
            <Menu.Item style={{ color: "white" }}>Contact us</Menu.Item>
          </Link>

          <Button
            className={appHeaderStyle.loginButton}
            onClick={() => {
              if (il == "1") {
                setOpen(true);
              } else {
                setOpen(true);
              }
            }}
            style={{ display: "flex", padding: "0px", gap: "1rem" }}
          >
            <img
              src={Loginicon}
              width={"22px"}
              style={{ marginLeft: "1rem" }}
              alt=""
            />
            Login
          </Button>
        </div>
      </Menu>
    </div>
  );
}

export default AppHeader;
